import { Shelf, sides } from '@/Interfaces/common';
import { transformPositionBySide } from '@/lib/transformPositionBySide';
import { Line3, Vector3 } from 'three';
import { $ } from '@/Engine/state';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { moveGroupToAnotherWall } from '@/Engine/eventHandlers/lib/moveGroupToAnotherWall';
import { rackShift } from '@/Constants/common';

function moveShelfToAnotherWall(shelf: Shelf, side: sides) {
    if ($.checkShelfCollisionWithWall(shelf, side)) {
        let direction = 1;
        if (shelf.position.x > 0.1)
            direction = -1;
        shelf.position =
            shelf.position
                .clone()
                .add(new Vector3(direction*shelf.width/2,0,0));
        shelf.computeObb();
    }
}

export function onPointerMoveToAnotherWall(side: sides, line: Line3) {
    // Запрет переноса полки в стойке в которой больше одной полки или если стойка в группе
    if ($.selectionBox.target && [ 'shelf','panel' ].includes($.selectionBox.target.type)) {
        const shelf = $.selectionBox.target as Shelf;
        if (!shelf.rackModule ||
            shelf.rackModule.shelves.length > 1 ||
            !shelf.rackModule.railGroup ||
            shelf.rackModule.railGroup.racks.length > 1
        ) return;
    }
    const oldSide = $.selectionBox.side;
    $.selectionBox.side = side;
    if ($.selectionBox.target) {
        const oldPosition = $.selectionBox.target.position.clone();
        const newPosition = transformPositionBySide(
            new Vector3().set(line.end.x, $.selectionBox.target.position.y, line.end.z),
            side,
            $.room,
        );

        $.pauseRender = true;
        $.room.addToWall($.selectionBox.target?.model, side);
        $.selectionBox.target.position = new Vector3(...newPosition);
        $.selectionBox.target.computeObb();

        if ($.selectionBox.target instanceof RackModule) {
            let direction = 1;
            if ($.selectionBox.target.position.x > 0.1)
                direction = -1;
            $.selectionBox.target.position =
                $.selectionBox.target.position
                    .clone()
                    .add(new Vector3(direction*($.selectionBox.target.width/2 + 3*rackShift),0,0));
            $.selectionBox.target.computeObb();
            $.selectionBox.target.shelves.forEach((shelf)=> {
                $.room.addToWall(shelf.model, side);
                shelf.position = shelf.position.clone();
                shelf.computeObb();
                // moveShelfToAnotherWall(shelf, side);
            });
            const rail = $.selectionBox.target.railGroup;
            if (rail?.model)
                $.room.addToWall(rail.model, side);
            $.pauseRender = false;
            $.render();
        }


        if ([ 'shelf', 'panel' ].includes($.selectionBox.target.type)) {
            moveShelfToAnotherWall($.selectionBox.target as Shelf, side);
            $.pauseRender = false;
            $.render();
            return true;
        } else {
            $.pauseRender = false;
            $.render();
        }

    }
    // Перемещение группы на другую стену
    if ($.selectionBox.targetGroup.length) {
        $.pauseRender = true;
        moveGroupToAnotherWall($.selectionBox.targetGroup, line.end, side);
        $.pauseRender = false;
        $.render();
    }
    return false;
}
